import * as React from 'react'

import type Employee from 'modules/employees/store/models/Employee'
import { buildForm } from 'modules/payroll_integrations/components/Form'
import codes from 'modules/payroll_integrations/store/collections/codes'

export function useCodeableForm(
  codeable: Employee,
  codeableType: string,
  codeableLabel: string,
  integration: string,
  forfaitJours = false
) {
  const initForm = buildForm(codeable, codeableType, codeableLabel, integration, forfaitJours)

  const [employeeForm, setEmployeeForm] = React.useState(initForm)
  React.useEffect(() => {
    async function codesFetch() {
      await codes.fetch({
        data: {
          integration: integration,
          codeable_id: codeable.id,
          codeable_type: codeableType,
          forfait_jours: forfaitJours,
        },
      })

      const form = buildForm(codeable, codeableType, codeableLabel, integration, forfaitJours)
      setEmployeeForm(form)
    }

    codesFetch()
  }, [codeable, codeableType, codeableLabel, integration, forfaitJours])

  return employeeForm
}
